/**
 * @module Admin Reports Reducer
 * @desc this Reducer help's us to maintain the Reports page api's data 
 * @return {Object} api's response
 */
import {POST_ISSUES, POST_ISSUES_SUCCESSFULL,POST_ISSUES_FAILED, GET_REPORT_LIST,GET_REPORT_LIST_SUCCESS,GET_REPORT_LIST_FAIL,
  GET_REPORT_LIST_FILE_DATA,GET_REPORT_LIST_FILE_DATA_SUCCESS,GET_REPORT_LIST_FILE_DATA_FAIL, GET_REPORT_LIST_SEARCH,
  UPDATE_REPORT_ISSUE_STATUS,UPDATE_REPORT_ISSUE_STATUS_SUCCESS,UPDATE_REPORT_ISSUE_STATUS_FAIL,
  GET_CHAT_MODAL_DATA,GET_CHAT_MODAL_DATA_SUCCESS, GET_CHAT_MODAL_DATA_FAIL, POST_MODAL_DATA,POST_MODAL_DATA_SUCCESS,POST_MODAL_DATA_FAIL,
  GET_CHAT_MODAL_DATA_CLIENT,POST_MODAL_DATA_CLIENT, GET_DELETE_TICKET, GET_DELETE_TICKET_SUCCESS, GET_DELETE_TICKET_FAIL, LAST_JSON_TICKET_REQUEST
} from "./actionTypes";


const initialState = {
  loader: false,
  reportIssueSuccess: null,
  reportIssueFailed: null,
  reportList : null,
  errorMessage: null,
  documentData: null,
  updateStatus: null,
  errorUpdateMsg: null,
  chatModalList: null, 
  chatLoader: null,
  chatStatus: false,
  statusLoader: false,
  deleteSuccess:null,
  deleteError:null,
  lastJson:null,
};


 /** 
   * @property {function} reportIssueReducer function handels the reports reducer functionality
   * @param {object} initialState state 
   * @param {func} function current action
   *  @desc based upon the action the reducer will add or remove the data in the initialstate object 
   */
const reportIssueReducer = (state = initialState, action) => {
  switch (action.type) {
    case POST_ISSUES:
      state = {
        ...state,
        loader: true,
        reportIssueSuccess: null,
        reportIssueFailed: null,
      };
      break;
    case POST_ISSUES_SUCCESSFULL:
      state = {
        ...state,
        loader: false,
        reportIssueSuccess: action.payload,
        reportIssueFailed: null,
      };
      break;
    case POST_ISSUES_FAILED:
      state = {
        ...state,
        loader: false,
        reportIssueSuccess: null,
        reportIssueFailed: action.payload,
      };
      break;
      case GET_REPORT_LIST_SEARCH:
        state = {
          ...state,
          loader: true,
          reportList: null,
          errorMessage: null,
        };
        break;
        case GET_REPORT_LIST:
        state = {
          ...state,
          loader: true,
          reportList: null,
          errorMessage: null,
        };
        break;
      case GET_REPORT_LIST_SUCCESS:
        state = {
          ...state,
          loader: false,
          reportList: action.payload,
          errorMessage: null,
        };
        break;
      case GET_REPORT_LIST_FAIL:
        state = {
          ...state,
          loader: false,
          reportList: null,
          errorMessage: action.payload
        };
        break;
        //file data
        case GET_REPORT_LIST_FILE_DATA:
          state = {
            ...state,
            loader: true,
            documentData: null,
            errorMessage: null,
          };
          break;
        case GET_REPORT_LIST_FILE_DATA_SUCCESS:
          state = {
            ...state,
            loader: false,
            documentData: action.payload,
            errorMessage: null,
          };
          break;
        case GET_REPORT_LIST_FILE_DATA_FAIL:
          state = {
            ...state,
            loader: false,
            documentData: null,
            errorMessage: action.payload
          };
          break;
           //update status
          case UPDATE_REPORT_ISSUE_STATUS:
            state = {
              ...state,
              loader: true,
              statusLoader: true,
              updateStatus: null,
              errorUpdateMsg: null
            };
            break;
          case UPDATE_REPORT_ISSUE_STATUS_SUCCESS:
            state = {
              ...state,
              loader: false,
              statusLoader:false,
              updateStatus: action.payload,
              errorUpdateMsg: null
            };
            break;
          case UPDATE_REPORT_ISSUE_STATUS_FAIL:
            state = {
              ...state,
              loader: false,
              statusLoader: false,
              updateStatus: null,
              errorUpdateMsg: action.payload,
            };
            break;

            case GET_CHAT_MODAL_DATA:
              state = {
                ...state,
                chatLoader: true,
                chatModalList: null,
              };
              break;
              case GET_CHAT_MODAL_DATA_CLIENT:
                state = {
                  ...state,
                  chatLoader: true,
                  chatModalList: null,
                };
                break;
              case GET_CHAT_MODAL_DATA_SUCCESS:
                state = {
                  ...state,
                  chatLoader: false,
                  chatModalList: action.payload,
                };
                break;
                case GET_CHAT_MODAL_DATA_FAIL:
                  state = {
                    ...state,
                    chatLoader: false,
                    chatModalList: null,
                  };
                  break;
              //post modal
              case POST_MODAL_DATA:
                state = {
                  ...state,
                  chatLoader: false,
                  chatStatus: false
                };
                break;
                //POST CLIENT
                case POST_MODAL_DATA_CLIENT:
                  state = {
                    ...state,
                    chatLoader: false,
                    chatStatus: false
                  };
                  break;
                case POST_MODAL_DATA_SUCCESS:
                  state = {
                    ...state,
                    chatLoader: false,
                    chatStatus: true
                  };
                  break;
                  case POST_MODAL_DATA_FAIL:
                    state = {
                      ...state,
                      chatLoader: false,
                      chatStatus:false,
                    };
                    break;

                     //ticket
                case GET_DELETE_TICKET:
                  state = {
                    ...state,
                    loader: true,
                    deleteSuccess:null,
                    deleteError:null
                  };
                  break;
                case GET_DELETE_TICKET_SUCCESS:
                  state = {
                    ...state,
                    loader: false,
                    deleteSuccess:action.payload,
                    deleteError:null
                  };
                  break;
                  case GET_DELETE_TICKET_FAIL:
                    state = {
                      ...state,
                      loader: false,
                      deleteSuccess:null,
                     deleteError:action.payload
                    };
                    break;

                    case LAST_JSON_TICKET_REQUEST:
                      state = {
                        ...state,
                       lastJson:action.payload,
                      };
                      break;


    default:
      state = { ...state };
      break;
  }
  return state;
};
export default reportIssueReducer;
